module.exports = __webpack_public_path__ + "img/inactiveError.b2c660e9.png";